import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import RedButton from 'Styled/RedButton';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '50vh', gap: 2 }}>
      <Typography variant="h1">404</Typography>
      <Typography variant="body1">Seite nicht gefunden</Typography>
      <RedButton onClick={() => navigate('/')}>Zur Startseite</RedButton>
    </Box>
  );
};
